import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { formatPickupTime, getPickupTimePickerLabel, isPickupTimeError } from "shared-ui/MenuOrder/utils";
import { PickupTime } from "shared-ui/MenuOrder/usePickupTimeState";
import { useClientTimezone } from "shared-ui/contexts/ClientTimezone";

interface MenuOrderFormTimePickerProps {
  className?: string;
  // label: string;
  forOrder: boolean;
  pickupTime: PickupTime | null;
  pickupTimes: PickupTime[];
  onChangePickupTime: (pickupTime: PickupTime) => void;
  mealMenuTimezone: string;
  disabled: boolean;
  openTimePicker?: boolean;
}

const MenuOrderFormTimePicker = ({
  className,
  // label,
  forOrder,
  disabled,
  onChangePickupTime,
  pickupTime,
  pickupTimes,
  mealMenuTimezone,
  openTimePicker,
}: MenuOrderFormTimePickerProps) => {
  const clientTimezone = useClientTimezone();

  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    if (openTimePicker !== undefined) {
      setPickerOpen(true);
    }
  }, [openTimePicker]);

  const pickupTimesWithFormat = pickupTimes.map(pickupTime => ({
    pickupTime,
    format: formatPickupTime({
      pickupTime,
      mealMenuTimezone,
      clientTimezone,
      forLog: !forOrder,
    }),
  }));

  const matchingPickupTime = pickupTimes.find(pt => {
    if (pickupTime?.type === "Time") {
      return pt.type === "Time" && pt.value === pickupTime.value;
    } else {
      return pt.type === "ASAP";
    }
  });

  const label = getPickupTimePickerLabel(forOrder);
  const error = isPickupTimeError(pickupTime, forOrder);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1Semibold" color={"mediumEmphasisTextLight"} sx={{ mt: 1, mb: 0.5 }}>{label}</Typography>
      <Select
        onOpen={() => setPickerOpen(true)}
        onClose={() => setPickerOpen(false)}
        open={pickerOpen}
        className={className}
        margin="none"
        error={error}
        disabled={disabled}
        value={
          pickupTime &&
          formatPickupTime({
            pickupTime,
            mealMenuTimezone,
            clientTimezone,
            forLog: !forOrder,
          })
        }
        onChange={e => {
          const matchingPickupTime = pickupTimesWithFormat.find(pt => pt.format === e.target.value);
          if (matchingPickupTime) {
            onChangePickupTime(matchingPickupTime.pickupTime);
          }
        }}
      >
        {pickupTimesWithFormat.map(({ format }) => (
          <MenuItem key={format} value={format}>
            {format}
          </MenuItem>
        ))}
        {pickupTime && !matchingPickupTime && (
          <MenuItem
            value={formatPickupTime({
              pickupTime,
              mealMenuTimezone,
              clientTimezone,
              forLog: !forOrder,
            })}
          >
            {formatPickupTime({
              pickupTime,
              mealMenuTimezone,
              clientTimezone,
              forLog: !forOrder,
            })}
          </MenuItem>
        )}
      </Select>
    </Box>
  );
};

export default MenuOrderFormTimePicker;
